import { render, staticRenderFns } from "./ActorCard.vue?vue&type=template&id=23ed285c&scoped=true&"
import script from "./ActorCard.vue?vue&type=script&lang=js&"
export * from "./ActorCard.vue?vue&type=script&lang=js&"
import style0 from "./ActorCard.vue?vue&type=style&index=0&id=23ed285c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed285c",
  null
  
)

export default component.exports